// extracted by mini-css-extract-plugin
export default {"root":"ClientFinances_root__3FyUu","table":"ClientFinances_table__y7WJl","pagination":"ClientFinances_pagination__3sd_Q"};